import styled, { css } from 'styled-components';

interface TabItemProps {
  isActive?: boolean;
}

export const TabListSticky = styled.div`
  width: 100%;
  width: var(--max-width);

  position: fixed;

  top: 0;
  background-color: #181818;
  z-index: 1;

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 8px 20px;
`;

export const TabList = styled.div`
  display: flex;
  gap: 12px;
  row-gap: 4px;
  width: 100%;
  height: 46px;
  background-color: var(--color-background);
  ${({ theme }) => theme.media.mobile} {
    width: 100vw;
    position: relative;
  }
`;

export const TabItem = styled.button<TabItemProps>`
  position: relative;
  width: 96px;
  height: 46px;
  text-align: center;
  color: ${({ theme }) => theme.palette.grayscale300};
  background: none !important;
  ${({ theme }) => theme.typography('$body_01')};
  font-weight: 500;
  ${({ isActive }) =>
    isActive &&
    css`
      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 4px;
        background-color: ${({ theme }) => theme.palette.brand400};
      }
    `}
`;
